var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            width: "960px",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            "show-close": false,
            "custom-class": "shopcar-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "detail-wrapper",
            },
            [
              _c(
                "button",
                { staticClass: "dialog-close", on: { click: _vm.handleClose } },
                [_c("i", { staticClass: "el-icon-close" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "detail-title" }, [_vm._v("订单详情")]),
              _vm._v(" "),
              _c("section", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-s-order" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("基础信息")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-grid" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单编号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.orderNo || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单状态："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "small",
                            type: _vm.getOrderStatusType(
                              _vm.detail.orderStatusName
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.detail.orderStatusName || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("下单时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.orderTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("关联小程序："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.appName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("支付时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.payTime || "--")),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-location" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("停车信息")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-grid" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("车牌号：")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value car-plate" }, [
                      _vm._v(_vm._s(_vm.detail.plateNo || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("停车场名称："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.parkName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("停车场编码："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.parkCode || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("出场时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.outTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("入场时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.inTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("停车时长："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value duration-text" }, [
                      _vm._v(_vm._s(_vm.detail.parkingDuration || "--")),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-bank-card" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("交易信息")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "trade-info" }, [
                  _c(
                    "div",
                    { staticClass: "trade-line" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单金额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value amount-highlight" }, [
                        _vm._v("￥" + _vm._s(_vm.detail.totalPrice || 0)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sub" }, [
                        _vm._v("\n              （福豆："),
                        _c("span", { staticClass: "fudou-amount" }, [
                          _vm._v("￥" + _vm._s(_vm.detail.useIntegral || 0)),
                        ]),
                        _vm._v("，\n              微信："),
                        _c("span", { staticClass: "wechat-amount" }, [
                          _vm._v("￥" + _vm._s(_vm.detail.paidPrice || 0)),
                        ]),
                        _vm._v("）\n            "),
                      ]),
                      _vm._v(" "),
                      _vm.detail.useIntegral > 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "link-btn",
                              attrs: { type: "text" },
                              on: { click: _vm.handleViewBeans },
                            },
                            [
                              _c("i", { staticClass: "el-icon-view" }),
                              _vm._v(" 查看福豆\n            "),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "trade-line" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("优惠方式："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.couponName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.detail.couponDiscount
                    ? _c("div", { staticClass: "trade-line discount-line" }, [
                        _c("i", { staticClass: "el-icon-discount" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "优惠券优惠：- ￥" +
                              _vm._s(_vm.detail.couponDiscount)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detail.thirdOrderInformation &&
                  _vm.detail.thirdOrderInformation.discount
                    ? _c("div", { staticClass: "trade-line discount-line" }, [
                        _c("i", { staticClass: "el-icon-discount" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "立减优惠：- ￥" +
                              _vm._s(_vm.detail.thirdOrderInformation.discount)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.detail.thirdOrderInformation
                ? _c("section", { staticClass: "detail-section" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _c("i", { staticClass: "el-icon-link" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("第三方机构信息")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单类型："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.orderTypeName ||
                                "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "info-item" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("订单状态："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.getOrderStatusType(
                                  _vm.detail.thirdOrderInformation
                                    .orderStatusName
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.detail.thirdOrderInformation
                                      .orderStatusName || "--"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("智慧停车订单编号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.orderCode || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("手机号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.phone || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("应收金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value amount-text" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.receivables ||
                                  0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("优惠金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value discount-amount" }, [
                          _vm._v(
                            "- ￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.discount || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("实收金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value amount-text" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.received || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("商户号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.merchantId ||
                                "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("商户名称："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.merchantName ||
                                "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("费率："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.rate || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("收单机构："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation
                                .acquiringInstitution || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("手续费："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value fee-amount" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.serviceFee || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("收费单位编码："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation
                                .chargingUnitCode || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("收费单位名称："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation
                                .chargingUnitName || "--"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "title" }, slot: "title" }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "福豆使用明细",
            visible: _vm.beansDialogVisible,
            width: "700px",
            "close-on-click-modal": false,
            "custom-class": "beans-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.beansDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "beans-detail-wrapper" },
            [
              _c("div", { staticClass: "beans-summary" }, [
                _c("div", { staticClass: "summary-card" }, [
                  _c("div", { staticClass: "summary-icon" }, [
                    _c("i", { staticClass: "el-icon-coin" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-content" }, [
                    _c("div", { staticClass: "summary-label" }, [
                      _vm._v("本次使用福豆"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-value" }, [
                      _vm._v(_vm._s(_vm.detail.useIntegral || 0)),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "beans-info-section" }, [
                _c("div", { staticClass: "info-title" }, [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("使用详情")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "beans-info-list" }, [
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("订单编号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.detail.orderNo || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("使用时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.detail.payTime || _vm.detail.orderTime || "--"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("停车场："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.detail.parkName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("车牌号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value car-plate" }, [
                      _vm._v(_vm._s(_vm.detail.plateNo || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("订单金额："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value amount-highlight" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.totalPrice || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("福豆抵扣："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value fudou-amount" }, [
                      _vm._v(_vm._s(_vm.detail.useIntegral || 0) + " 福豆"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("微信支付："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value wechat-amount" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.paidPrice || 0)),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.beansDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }